/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFuelPriceMonthly.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/fuel-price-monthly";

export class AutogenModelFuelPriceMonthly<RowType extends ModelRow> extends Endpoint<RowType, RowFuelPriceMonthlyFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFuelPriceMonthly extends ModelRow<RowFuelPriceMonthlyFields> {
	constructor(values?: Partial<RowFuelPriceMonthlyFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFuelPriceMonthlyFields {
	average_price: number;
	california_price: number;
	cntrl_atlntc_price: number;
	company_id: string;
	east_coast_price: number;
	gulf_coast_price: number;
	lower_atlntc_price: number;
	midwest_price: number;
	new_england_price: number;
	price_date: Date;
	rocky_mtn_price: number;
	west_coast_less_california: number;
	west_coast_price: number;
}

